import React, { useContext } from 'react';
import {
  okText,
  upgradeModalContent,
  upgradeModalTitle,
} from '../../i18n/translations';
import './index.scss';
import { modalContext } from './modal.provider';

const UpgradeModal: React.FC = () => {
  const { isVisible, setIsVisible } = useContext(modalContext);
  function closeModal(): void {
    setIsVisible(false);
    document.body.style.overflow = 'unset';
  }

  if (isVisible) {
    return (
      <div className="upgrade-modal overlay" onClick={closeModal}>
        <div className="modal centered">
          <h3>{upgradeModalTitle()}</h3>
          <p>{upgradeModalContent()}</p>
          <div className="btn-container">
            <button onClick={closeModal}>{okText()}</button>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default UpgradeModal;
